import { render, staticRenderFns } from "./EternityChallengeBoxWrapper.vue?vue&type=template&id=4d90efa2&scoped=true&"
import script from "./EternityChallengeBoxWrapper.vue?vue&type=script&lang=js&"
export * from "./EternityChallengeBoxWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90efa2",
  null
  
)

export default component.exports